/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import { genMedicineInstruction } from 'Helpers/utils';
import { func, shape, string } from 'prop-types';
import React from 'react';
import { Icon, Input } from 'semantic-ui-react';
// import editIcon from 'Assets/images/commons/editMed.svg';
// import removeIcon from 'Assets/images/commons/removeMed.svg';
import { CurrencyLabel } from 'Modules/Currency';

import styles from './MedicineDetails.less';

const MedicineDetails = props => {
  const {
    details: { description, quantity, uomUnit, ottersgProductId, lifepackProductId },
    onEdit,
    onRemove,
    onDecreaseQuantity,
    onIncreaseQuantity,
    onSetQuantity,
    currencySymbol,
    details: medicine,
  } = props;

  const isMedicineFromStorage = !!ottersgProductId || !!lifepackProductId;
  const instruction = genMedicineInstruction(medicine, isMedicineFromStorage);

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.medImg} />

        <div className={styles.content}>
          <div>{description.name}</div>
          <div className={styles.priceQuantityRow}>
            {/* <div className={styles.actions}>
              <a onClick={onEdit} className={styles.actionItem}>
                <img src={editIcon} alt="edit" />
              </a>
              <a onClick={onRemove} className={styles.actionItem}>
                <img src={removeIcon} alt="remove" />
              </a>
            </div> */}
            <strong>
              {currencySymbol} <CurrencyLabel value={description.unitPrice} />
            </strong>
            <div className={styles.quantityControls}>
              <div className={`${styles.styleIcon} ${styles.quantityWrapper}`}>
                <Icon
                  name="minus"
                  className={styles.minusIcon}
                  onClick={onDecreaseQuantity}
                  disabled={quantity < 2}
                />
                <span className={styles.quantityInput}>
                  <Input
                    type="text"
                    value={quantity}
                    onChange={(e, data) => {
                      // only allow number input
                      if (!/^\d+$/.test(e.target.value) && e.target.value !== '') return;
                      onSetQuantity(data.value);
                    }}
                  />
                </span>
                <Icon
                  name="plus"
                  className={styles.plusIcon}
                  onClick={+quantity < 999 ? onIncreaseQuantity : null}
                  disabled={+quantity === 999}
                />
              </div>
              <span className={styles.uomUnit}>{uomUnit}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.instruction}>
        <span>{instruction}</span>
      </div>

      <div className={styles.actionButtons}>
        <a onClick={onEdit} className={styles.editButton}>
          Edit
        </a>
        <a onClick={onRemove} className={styles.deleteButton}>
          Delete
        </a>
      </div>
    </div>
  );
};

MedicineDetails.propTypes = {
  details: shape({
    note: string,
  }).isRequired,
  onEdit: func.isRequired,
  onRemove: func.isRequired,
  onDecreaseQuantity: func.isRequired,
  onIncreaseQuantity: func.isRequired,
  onSetQuantity: func.isRequired,
  currencySymbol: string.isRequired,
};

MedicineDetails.defaultProps = {};

export default MedicineDetails;
